import { Outlet } from "react-router-dom";
import "../Layouts/Layout.scss";
import { useSearchParams, Router, Link } from "react-router-dom";
import { useState, useEffect } from "react";
import Select_Input from "../../components/UI/Select_Input";
import { useSelector, useDispatch } from "react-redux";
import { getRequest } from "../../apiService"; // NEW IMPORT


const TopLocked_scroll_pg = (props) => {
  const [inputs, setInputs] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();
  const [yearData, setYearData] = useState([]);
  
  const pgSubNavs = [{pgName: 'Manage Calculator', defaultPg: 'Office',  subPgs: 
    [
      {pg: 'Office', urlVal: 'office' }, 
      {pg: 'Portal', urlVal: 'portal'}
    ]
  }];

  useEffect(() => {
    document.title = props.title;
  }, [props.title]);

  useEffect(() => {
    initializeData();
  }, []);

  const initializeData = async () => {
    const result = await getRequest("type/getRequestedType/?id=36");
    
    if (result.success) {
      setYearData(result.data.data);
    } else {
      console.error("Failed to load Financial Year data:", result.error);
    }
  };

  function subNavData(){
    let match = pgSubNavs.filter((f)=> f.pgName === props.title).map((x)=> x.subPgs);
    return match;
  }

  function renderActiveSubPg(){
    let validSubPgs = subNavData()[0].map((x)=> x.pg.toLowerCase());
    let defaultPg = pgSubNavs.filter((f)=> f.pgName === props.title).map((x)=> x.defaultPg.toLowerCase());
    let urlCurrentPg = validSubPgs.includes(searchParams.get("pg")) ? searchParams.get("pg") : defaultPg[0].toLowerCase();
    return urlCurrentPg;
  }

  function updateSelectFields(inputField, newValue) {
    setInputs((values) => ({ ...values, [inputField]: newValue }));
  }

  return (
    <>
      <div id={typeof props.id !== "undefined" ? "pg_"+props.id : ""} className="pg-grid-center">
        <div className="top-locked-fit">
        <h1 className="pg-title">{props.title}</h1>
        {subNavData() && subNavData().length > 0 && 
       <div id="sub-pg-nav-2"> 
        {subNavData()[0].map((x, index)=>
          <>
          <Link
          key={index}
          id={"subPg-"+x.urlVal}
          className={renderActiveSubPg() === x.pg.toLowerCase() ? "sub-pg-active" : ""}
          to={`?${new URLSearchParams({pg: x.urlVal})}`} replace
        >
          {x.pg}
        </Link>
        </>
        )}
        {typeof props.title !== "undefined" && props.title === "Manage Calculator" && yearData.length > 0 &&
            <Select_Input
                  data={yearData}
                  defaultTxt="Year"
                  desc="Financial Year Select"
                  defaultValue="0"
                  optionSelectedOnLoad={2476}
                  defaultSelectable={false}
                  inputName={"financial-year-select"}
                  id={"financial-year-select"}
                  optionId={"id"}
                  optionValue={"name"}
                  newStructureOptions={false}
                  updateSelectChange={updateSelectFields}
                  classes={"select-pg-outsideModal"}
                />
            }
      </div>
        }
        </div>
        <div id="body-content">
        <Outlet />
        </div>
      </div>
    </>
  );
};
export default TopLocked_scroll_pg;